export default __webpack_public_path__ + "static/media/tag_medium.41322df7.png";